import type { LinkCardProps } from "@op/puck-types";
import { Dc_Media_Link_Card } from "@op/sf-op";
import { useMemo } from "react";
import Medium from "../../../../../components/puck/Medium/Medium";

const LinkCard = ({
  image,
  link,
  isMarginal,
  title,
  publisher,
}: LinkCardProps) => {
  const hasNoImage = useMemo(() => !image, [image]);
  const isSourceVideo = useMemo(() => link.includes("youtube.com"), [link]);
  const isInternalLink = useMemo(() => link.startsWith("/"), [link]);
  const target = useMemo(
    () => (isInternalLink ? "_self" : "_blank"),
    [isInternalLink]
  );

  return (
    <a href={link} target={target} className="contents">
      <Dc_Media_Link_Card
        hasNoImage={hasNoImage}
        imageSlot={image && <Medium cover medium={image} />}
        text={title}
        publisher={publisher}
        isSourceVideo={isSourceVideo}
        isContent={isMarginal}
      />
    </a>
  );
};

export default LinkCard;
